import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PromotionType } from 'domain/models/promotion'
import { PromotionDetail } from 'domain/entities/promotion'
import { RootState } from 'presentation/redux/reducers'

const initialState: PromotionType = {
  error: null,
  errorCreating: null,
  errorUpdating: null,
  isLoading: false,
  isLoadingCreating: false,
  isLoadingUpdating: false,
  promotion: null,
}

export const promotionSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    getPromotionGoalsStart: (state: PromotionType) => {
      state.isLoading = true
      state.error = null
      state.errorCreating = null
      state.errorUpdating = null
    },
    getPromotionGoalsSuccess: (state: PromotionType, action: PayloadAction<PromotionDetail>) => {
      state.isLoading = false
      state.promotion = action.payload
    },
    getPromotionGoalsError: (state: PromotionType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    createPromotionGoalsStart: (state: PromotionType) => {
      state.error = null
      state.errorCreating = null
      state.errorUpdating = null
      state.isLoadingCreating = true
    },
    createPromotionGoalsSuccess: (state: PromotionType) => {
      state.isLoadingCreating = false
    },
    createPromotionGoalsError: (state: PromotionType, action: PayloadAction<string>) => {
      state.isLoadingCreating = false
      state.errorCreating = action.payload
    },
    updatePromotionGoalsStart: (state: PromotionType) => {
      state.error = null
      state.errorCreating = null
      state.errorUpdating = null
      state.isLoadingUpdating = true
    },
    updatePromotionGoalsSuccess: (state: PromotionType) => {
      state.isLoadingUpdating = false
    },
    updatePromotionGoalsError: (state: PromotionType, action: PayloadAction<string>) => {
      state.isLoadingUpdating = false
      state.errorUpdating = action.payload
    },
    clearPromotionGoals: (state: PromotionType) => {
      state.promotion = null
    },
  },
})

export const promotionState = (state: RootState) => state.promotion
export const {
  getPromotionGoalsStart,
  getPromotionGoalsSuccess,
  getPromotionGoalsError,
  createPromotionGoalsStart,
  createPromotionGoalsSuccess,
  createPromotionGoalsError,
  updatePromotionGoalsSuccess,
  updatePromotionGoalsStart,
  updatePromotionGoalsError,
  clearPromotionGoals,
} = promotionSlice.actions

export default promotionSlice.reducer
